import styled, { css } from 'styled-components';

export default styled.div`
  @media all and (min-width: ${({ theme }) => theme.breakingpoints.lg}) {
    display: flex;
    justify-content: space-between;
     ${({ $dark }) => !$dark && css`
      margin-top: 1.5rem;
    `}
  }

  > div:first-child {
    flex-grow: 1;
  }

  ${({ $dark, theme }) => $dark && css`
    margin-top: 0;
    background-color: ${theme.gray01};
    padding: 1rem;
    font-weight: bold;
    text-align: center;
  `}
`;
